import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccessLog } from '../models/access-log.model';
import { GridService } from '../shared/grid/grid.service';

@Injectable({
  providedIn: 'root'
})
export class AccessLogService extends GridService<AccessLog> {

  constructor(http: HttpClient) {
    super('AccessLog', http);
  }
}
